import React, { useEffect } from 'react';
import { saveYoutubePlayerState } from '../../../helpers/lurker';
export default function YoutubePlayer(_ref) {
  var idYoutube = _ref.idYoutube;
  var hasStarted = false;
  var isPaused = false;
  useEffect(function () {
    if (idYoutube) {
      if (!window.YT) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        window.onYouTubeIframeAPIReady = loadVideo;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        loadVideo();
      }
    }
  }, [idYoutube]);
  var loadVideo = function loadVideo() {
    new YT.Player("youtube-player-".concat(idYoutube), {
      videoId: idYoutube,
      width: '100%',
      playerVars: {
        autoplay: 0,
        controls: 2,
        enablejsapi: 1,
        origin: window.location.origin
      },
      events: {
        onStateChange: onPlayerStateChange,
        onError: onPlayerError
      }
    });
  };
  var onPlayerStateChange = function onPlayerStateChange(e) {
    var titleVideo = e.target.videoTitle;
    if (e.data == window.YT.PlayerState.PLAYING) {
      if (!hasStarted) {
        hasStarted = true;
        saveYoutubePlayerState({
          idYoutube: idYoutube,
          titleVideo: titleVideo,
          state: 'STARTED'
        });
      } else if (isPaused) {
        isPaused = false;
        saveYoutubePlayerState({
          idYoutube: idYoutube,
          titleVideo: titleVideo,
          state: 'UNPAUSED'
        });
      }
    } else if (e.data == window.YT.PlayerState.PAUSED) {
      isPaused = true;
      saveYoutubePlayerState({
        idYoutube: idYoutube,
        titleVideo: titleVideo,
        state: 'PAUSED'
      });
    } else if (e.data == window.YT.PlayerState.ENDED) {
      saveYoutubePlayerState({
        idYoutube: idYoutube,
        titleVideo: titleVideo,
        state: 'ENDED'
      });
      hasStarted = false;
      isPaused = false;
    }
  };
  var onPlayerError = function onPlayerError(e) {
    saveYoutubePlayerState({
      idYoutube: idYoutube,
      titleVideo: titleVideo,
      state: 'ERROR',
      error: e.data
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "youtube-player-".concat(idYoutube)
  });
}